import type {MenuItemConfig} from '@myparcel-frontend/ui';
import {Shipment} from '@myparcel-frontend/icons/legacy';
import {markRaw} from 'vue';

export const getShipmentsMenu = ({
  collectTrip = {enabled: false},
  enableLocationFinder = false,
  hasShipmentsOverview = false,
}: {
  collectTrip: {enabled: boolean; type?: 'internal' | 'external'; url?: string};
  enableLocationFinder: boolean;
  hasShipmentsOverview?: boolean;
}): MenuItemConfig => {
  const menuItems = {
    type: 'parent',
    label: 'shipment.index.shipment',
    multiplyLabel: true,
    icon: markRaw(Shipment),
    show: () => hasShipmentsOverview,
    children: [
      {
        type: 'internal',
        to: {
          name: 'shipments',
        },
        label: 'overview',
      },
      {
        type: 'internal',
        to: {
          name: 'shipments-create',
        },
        label: 'shipment.newShipment',
      },
      {
        type: 'internal',
        to: {
          name: 'shipments-import',
        },
        label: 'shipment.multiple',
      },
      {
        type: 'internal',
        to: {
          name: 'addresses',
        },
        label: 'location.addressBook.addressBook',
      },
    ],
  };

  if (collectTrip.enabled) {
    if (collectTrip.type === 'internal') {
      menuItems.children.push({
        type: 'internal',
        to: {
          name: 'collect-trip',
        },
        label: 'collectTrip.title',
      });
    } else if (collectTrip.type === 'external' && collectTrip.url) {
      menuItems.children.push({
        type: 'external',
        href: collectTrip.url,
        label: 'collectTrip.title',
      });
    }
  }

  if (enableLocationFinder) {
    menuItems.children.push({
      type: 'internal',
      to: {
        name: 'location-finder',
      },
      label: 'location.locationFinder.title',
    });
  }

  return menuItems;
};
